import {
  CASE_UPDATE_DIALIN_NUMBERS_BEGIN,
  CASE_UPDATE_DIALIN_NUMBERS_SUCCESS,
  CASE_UPDATE_DIALIN_NUMBERS_FAILURE,
  CASE_UPDATE_DIALIN_NUMBERS_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const updateDialInNumbers = createPromiseAction(CASE_UPDATE_DIALIN_NUMBERS_BEGIN);

export function dismissUpdateDialInNumbersFeedback() {
  return {
    type: CASE_UPDATE_DIALIN_NUMBERS_DISMISS_FEEDBACK,
  };
}

export function* doUpdateDialInNumbers(action) {
  const { caseId, number } = action.payload;

  let res = yield call(api.put, `/cases/${caseId}/dial-in-numbers`, { number });

  if (res && res.error) {
    yield put({
      type: CASE_UPDATE_DIALIN_NUMBERS_FAILURE,
      feedback: {
        message: 'feedback.UpdateDialInNumbersFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_UPDATE_DIALIN_NUMBERS_SUCCESS,
    data: { dialInNumbers: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchUpdateDialInNumbers() {
  yield takeLatest(updateDialInNumbers, withCurrentCaseId(doUpdateDialInNumbers));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_UPDATE_DIALIN_NUMBERS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        updateDialInNumbersPending: true,
        updateDialInNumbersFeedback: null,
      };

    case CASE_UPDATE_DIALIN_NUMBERS_SUCCESS:
      // The request is success
      return {
        ...state,
        updateDialInNumbersPending: false,
        updateDialInNumbersFeedback: action.feedback,
      };

    case CASE_UPDATE_DIALIN_NUMBERS_FAILURE:
      // The request is failed
      return {
        ...state,
        updateDialInNumbersPending: false,
        updateDialInNumbersFeedback: action.feedback,
      };

    case CASE_UPDATE_DIALIN_NUMBERS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        updateDialInNumbersFeedback: null,
      };

    default:
      return state;
  }
}
